module.exports = __webpack_public_path__ + "39d06883416a0fea2a3cbffe7181f7d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/goldenegg/egg-open-0.png
// module id = 514
// module chunks = 0